export default __webpack_public_path__ + "static/media/97.3f9e456d.png";